import PropTypes from 'prop-types';
import InputAdornment from '@material-ui/core/InputAdornment';
import CountryMenu from '@cont/Login/CountryMenu';
import Field from '@base/Form/Field';
import {
  FormContainer,
  StyledTextField,
  FormSectionHeading,
  FieldWrapper,
  StyledNumberField,
  StyledDropdown,
  Error
} from './styles';
import { isRequired } from './utils';
import { bloodGroups } from '../constants';

const renderErrorMessage = ({ message }) => {
  return <Error>{message}</Error>;
};

const PersonalDetails = ({ registrar, country, updateStoreData }) => {
  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <FormContainer>
      <FormSectionHeading>Learner details</FormSectionHeading>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name="fullName"
          render={({ onChange, value }) => (
            <StyledTextField
              placeholder="Enter full name"
              value={value}
              onChange={(data) => onChange(data)}
              disabled
            />
          )}
        />
      </FieldWrapper>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name="phoneNum"
          rules={[isRequired('Mobile number is required')]}
          render={({ value }) => (
            <StyledNumberField
              fullWidth
              startAdornment={
                <InputAdornment>
                  <CountryMenu country={country} disabled />
                </InputAdornment>
              }
              placeholder="Enter your mobile number"
              onChange={() => {}}
              value={value}
              inputProps={{
                type: 'tel',
                maxLength: 10,
                required: true
              }}
              type="tel"
              disabled
            />
          )}
        />
      </FieldWrapper>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name="bloodGroup"
          rules={[isRequired('Blood group is required')]}
          render={({ onChange, value }) => (
            <StyledDropdown
              options={bloodGroups}
              placeholder="Select your blood group"
              selectedOption={value}
              onOptionClick={(data) => {
                onChange(data);
                updateStoreData('bloodGroup', data);
              }}
              buttonWidth="100%"
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapper>
    </FormContainer>
  );
};

PersonalDetails.propTypes = {
  registrar: PropTypes.objectOf(PropTypes.any).isRequired,
  country: PropTypes.objectOf(PropTypes.any).isRequired
};

export default PersonalDetails;
